import {combineReducers} from 'redux';
import  UserReducer from './reducer_user';
import  ProductsReducer  from './reducer_products';
import  AdminProductsReducer  from './reducer_admin_products';
import  AdminGBGProductsReducer  from './reducer_admin_gbg_products';
import  AdminSubscriptionsReducer  from './reducer_admin_subscriptions';
import  AdminServicesReducer  from './reducer_admin_services';
import  AdminOrdersReducer  from './reducer_admin_orders';
import  AdminPalletsReducer  from './reducer_admin_pallets';
import  SellersReducer  from './reducer_admin_sellers';
import  ContractorsReducer  from './reducer_admin_contractors';
import  AdminPromoCodesReducer  from './reducer_admin_promocodes';
import  TransactionsReducer  from './reducer_admin_transactions';
import  UsersReducer  from './reducer_admin_users';
import  UsersDataReducer  from './reducer_admin_users_data';
import  AppDataReducer  from './app_data_reducer';
import  FocusAreasReducer  from './reducer_focus_areas'
import  AllSellersPickupsReducer  from './reducer_all_sellers_pickups';
import  MetroAreasReducer  from './reducer_metro_areas';
import  VehoZipCodesReducer  from './reducer_veho_zip_codes';
//import  SellerProductsReducer  from './reducer_seller_products';
import  SellerServicesReducer  from './reducer_seller_services';
import  allSellersListReducer  from './reducer_all_sellers_list';
import  allContractorsListReducer  from './reducer_all_contractors_list';

const rootReducer = combineReducers({
    //currentUser: CurrentUserReducer,
    userReducer: UserReducer,
    products: ProductsReducer,
    adminProducts: AdminProductsReducer,
    adminGBGProducts: AdminGBGProductsReducer,
    adminSubscriptions: AdminSubscriptionsReducer,
    adminServices: AdminServicesReducer,
    adminTransactions: TransactionsReducer,
    adminSellers: SellersReducer,
    adminUsers: UsersReducer,
    allSellersList: allSellersListReducer,
    allContractorsList: allContractorsListReducer,
    appData: AppDataReducer,
    focusAreas: FocusAreasReducer,
    metroAreas: MetroAreasReducer,
    vehoZipCodes:VehoZipCodesReducer,
    adminUsersData: UsersDataReducer,
    adminOrders: AdminOrdersReducer,
    adminPallets:AdminPalletsReducer,
    allSellerPickupsListReducer:AllSellersPickupsReducer,
    // sellerProducts:SellerProductsReducer,
    adminContractors: ContractorsReducer,
    sellerServices: SellerServicesReducer,
    adminPromoCodes: AdminPromoCodesReducer
});

export default rootReducer;